export const addresses = {
  token: "0xC7FA5764f936bEB859869a96d336D29D9cFe7D25",
};
